import type { FunnelKind, MeetingSlotFormValues } from './types';

type ValidateMeetingSlotSubmitParams = {
  deadlineISO: string | null;
  funnelKind: FunnelKind;
  selectedSlot: string;
  ufCrmTask: string[];
  userId?: number | null;
  values: MeetingSlotFormValues;
};

export function validateMeetingSlotSubmit({
  deadlineISO,
  funnelKind,
  selectedSlot,
  ufCrmTask,
  userId,
  values,
}: ValidateMeetingSlotSubmitParams) {
  if (!selectedSlot) {
    return 'Слот не выбран';
  }
  if (!deadlineISO) {
    return 'Не смог разобрать время слота';
  }
  if (!userId) {
    return 'Не определён пользователь';
  }

  if (funnelKind === 'lead' && !values.leadId) {
    return 'Выберите лид из списка';
  }
  if (funnelKind === 'smart_process' && !values.projectId) {
    return 'Выберите проект из списка';
  }
  if (funnelKind === 'deal' && !values.dealId) {
    return 'Выберите сделку из списка';
  }
  if (ufCrmTask.length === 0) {
    return 'CRM-привязка не сформирована';
  }

  return null;
}
